<template>
  <div>
    <Label bold v-if="label != null" :disabled="disabled">
      {{ label }}
    </Label>
    <vSelect
        :label="labelSearch"
        :class="inputClass"
        :ref="reference"
        :options="options"
        :placeholder="placeholderInField"
        :resetOnOptionsChange="true"
        :disabled="disabled"
        :value="value"
        @input="handleChange"
        @search="handleSearch"
    >
        <template slot="no-options">
            {{ placeholder }}
        </template>
        <template slot="option" slot-scope="option">
            <slot name="options" :data="option"></slot>
        </template>
        <template slot="selected-option" slot-scope="option">
            <slot name="selected" :data="option"></slot>
        </template>
    </vSelect>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Label from './Label';

export default {
  name: 'Select',
  components: {
    vSelect,
    Label,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    labelSearch: {
      type: String,
      default: 'name',
    },
    placeholderInField: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
    },
    reference: {
      type: String,
    },
    inputClass: {
      type: String,
    },
    filterable: {
      type: Boolean,
      default: false,
    },
    change: {
      type: Function,
      required: true,
    },
    search: {
      type: Function,
      required: true,
    },
    options: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: null,
    },
    description: {
      type: String,
    },
    success: {
      type: Boolean,
      default: () => false,
    },
    error: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleChange(selected) {
      this.change(selected);
    },
    handleSearch(search, loading) {
      this.search(search, loading);
    },
  },
  computed: {
    descriptionClass() {
      return {
        success: this.success,
        error: this.error,
      };
    },
  },
};
</script>

<style>
.vs--disabled > div {
  border: 2px solid #dedede !important;
  color: #7e7e7e !important;
  background-color: #e9ecef !important;
  opacity: 1;
}

.vs--disabled input {
  background-color: #e9ecef !important;
}
</style>
